// @owners { team: patients }
import { CLEAR_DELIVERY_NOTIFICATIONS, type DeliveryActions, SET_DELIVERIES } from '~shared/actions/deliveries';
import { type LightDelivery } from '~shared/types';

export type DeliveryState = {
  deliveries: LightDelivery[];
  lastRequestAttemptedAt: number;
  requestAttemptCount: number;
  lastFetchAllRequestSucceededAt: number;
  lastRequestSucceededAt: number;
  selectedOrderID: number | string | null;
};

const initialState: DeliveryState = {
  deliveries: [],
  lastRequestAttemptedAt: 0,
  requestAttemptCount: 0,
  lastFetchAllRequestSucceededAt: 0,
  lastRequestSucceededAt: 0,
  selectedOrderID: null,
};

const deliveries = (state = initialState, action: DeliveryActions): DeliveryState => {
  switch (action.type) {
    case SET_DELIVERIES:
      // Bridge sync from React Query (merged all + active). Keep timestamp fields populated so any
      // staleness/loading selectors reading them keep behaving.
      return {
        ...state,
        deliveries: action.payload,
        lastRequestSucceededAt: Date.now(),
        lastFetchAllRequestSucceededAt: Date.now(),
        requestAttemptCount: 0,
      };

    case CLEAR_DELIVERY_NOTIFICATIONS:
      return { ...state };

    default:
      return state;
  }
};

export default deliveries;
